angular.module("app").component("templateFooter", {
  templateUrl: "app/template/footer.html",
  controller: FooterController,
  controllerAs: "vm",
});

FooterController.$inject = [];

function FooterController() {}
